export enum UrlCommand {
  ShowSelfTapesSendingSuccess = 'showSelfTapesSendingSuccess',
}
